import { ChangeDetectionStrategy, Component, input, output, ViewEncapsulation } from "@angular/core";
import { ReportBuilderCell } from "./s25.document.report.builder.table.component";
import { Doc } from "./s25.document.const";

@Component({
    standalone: false,
    selector: "s25-ng-document-report-builder-cell",
    template: `
        @if (editable()) {
            @let popoverBean = { popoverTemplate: editCellTemplate };
            <s25-popover [openTrigger]="'click'" [closeTrigger]="'click'" [modelBean]="popoverBean" [inline]="false">
                <ng-container [ngTemplateOutlet]="cellTemplate" />
            </s25-popover>
        } @else {
            <ng-container [ngTemplateOutlet]="cellTemplate" />
        }

        <ng-template #cellTemplate>
            <div class="style-container" [class.invalid]="!cell().valid()" [style]="cell().css()">
                @if (cell().variable()) {
                    @if (cell().label()) {
                        <span>{{ cell().label() }}</span>
                    }

                    @if (cell().variable().type() === "subreport" && cell().variable().subreportId) {
                        <s25-ng-document-report-builder
                            [documentId]="cell().variable().subreportId"
                            [editable]="false"
                            (reportBuilderChange)="cell().variable().subreport = $event; changed.emit()"
                        />
                    } @else {
                        <span>{{ cell().display() }}</span>
                    }
                }
            </div>
        </ng-template>

        <ng-template #editCellTemplate>
            <s25-ng-document-report-builder-cell-editor
                [cell]="cell()"
                [documentType]="documentType()"
                (changed)="changed.emit()"
            />
        </ng-template>
    `,
    styles: `
        :host {
            display: block;
            height: 100%;
            overflow: hidden;
        }

        .style-container {
            overflow: hidden;
            height: 100%;
            align-content: end;
            overflow-wrap: anywhere;
            padding: 0.25rem 0.5rem;
        }

        .style-container:has(s25-ng-document-report-builder) {
            padding: 0;
        }

        .invalid {
            background-color: color-mix(in hsl, var(--red), transparent 85%);
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentReportBuilderCellComponent {
    documentType = input.required<Doc.SubreportTypeId>();
    cell = input.required<ReportBuilderCell>();
    editable = input.required<boolean>();

    changed = output<void>();
}
